import React, { useEffect } from 'react';
import { Box, TextInput, Group, ActionIcon, Divider } from '@mantine/core';
import { X } from 'tabler-icons-react';

function NumberDictationEpreuve({ form, index, onRemove, generateAdjustedChoices }) {
    useEffect(() => {
        // Initialize consigne if it doesn't exist
        if (!form.values.epreuves[index].consigne) {
            form.setFieldValue(`epreuves.${index}.consigne`, [{ value: '' }]);
        }
    }, []);

    const handleValueChange = (idx, value) => {
        const number = parseInt(value.trim(), 10);
        if (!isNaN(number)) {
            // Update consigne
            form.setFieldValue(`epreuves.${index}.consigne.${idx}`, { value: number.toString() });
            // Update correction_dp
            form.setFieldValue(`epreuves.${index}.correction_dp.${idx}`, number.toString());
            // Update choices
            form.setFieldValue(`epreuves.${index}.choices.${idx}`, generateAdjustedChoices(number));
        } else {
            // If not a valid number, just update the input value
            form.setFieldValue(`epreuves.${index}.consigne.${idx}`, { value: value });
        }
    };

    return (
        <Box key={index}>
            <TextInput
                placeholder="Entrez un titre pour l'exercice"
                mb={10}
                radius={10}
                {...form.getInputProps(`epreuves.${index}.titre`)}
            />
            <Group position="apart">
                <Group>
                    {form.values.epreuves[index].consigne?.map((subItem, idx) => (
                        <TextInput
                            key={idx}
                            placeholder="Nombre dicté"
                            radius={10}
                            w={200}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={typeof subItem === 'string' ? subItem : subItem.value}
                            onChange={(e) => handleValueChange(idx, e.target.value)}
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    ))}
                </Group>
                <ActionIcon color="red" onClick={() => onRemove(index)}>
                    <X size="1rem" />
                </ActionIcon>
            </Group>
            <Divider my={20} />
        </Box>
    );
}

export default NumberDictationEpreuve; 